export const MOBILE_MEDIA_QUERY = '@media (min-width: 768px)'

export const hexToRGBA = (hex: string, alpha = 0.15): string => {
  let cleanHex = hex.replace(/^#/, '')

  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split('')
      .map((c) => c + c)
      .join('')
  }

  const r = parseInt(cleanHex.substring(0, 2), 16)
  const g = parseInt(cleanHex.substring(2, 4), 16)
  const b = parseInt(cleanHex.substring(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const darkenRGBA = (rgba: string, amount: number = 0.1): string => {
  const parts = rgba.replace(/rgba?\(|\s+|\)/g, '').split(',')

  let [r, g, b, a = 1] = parts.map(Number)

  r = Math.max(0, Math.floor(r * (1 - amount)))
  g = Math.max(0, Math.floor(g * (1 - amount)))
  b = Math.max(0, Math.floor(b * (1 - amount)))

  return `rgba(${r}, ${g}, ${b}, ${a})`
}
